import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, inject, onMounted, provide, ref, useSlots } from 'vue'
import type { NavItem } from '@/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'LzNavItem',
  props: {
    title: {},
    depth: {},
    highlight: { type: Boolean },
    link: {},
    linkTitle: {},
    target: {},
    icon: {},
    items: {},
    active: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const registerMain = inject<(item: NavItem) => void>('registerMainNavItem')
const registerSub = inject<(item: NavItem) => void>('registerSubNavItem', () => undefined)
const items = ref<NavItem[]>([])
const slots = useSlots()
const isActive = computed(() => (props.link && location.pathname === props.link) || items.value.some(x => x.active));

provide('registerSubNavItem', registerSubNavItem)

onMounted(() => {
    if (!slots.items || slots.items({}).length === 0) {
        // no sub-items -> register directly
        registerSelf()
    }
})

function registerSubNavItem(item: NavItem) {
    // check depth to only register direct children
    // since provide is passed down to all descendants
    if (item.depth === props.depth + 1) {
        items.value.push(item)
    }
    if (items.value.length === slots.items({}).length) {
        // register after all sub-items have been registered
        registerSelf()
    }
}

function registerSelf() {
    // distinguish main nav items from rest
    if (props.depth === 1) {
        registerMain({ ...props, items: items.value, active: isActive.value })
    } else {
        registerSub({ ...props, items: items.value, active: isActive.value })
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _renderSlot(_ctx.$slots, "items")
  ], 64))
}
}

})